import { render, staticRenderFns } from "./ComponentCampaignMerchantsTable.vue?vue&type=template&id=b894c0fe&"
import script from "./ComponentCampaignMerchantsTable.vue?vue&type=script&lang=js&"
export * from "./ComponentCampaignMerchantsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VDataTable,VToolbar,VToolbarTitle})
